import {
  GeInfo,
  Icon,
  Text,
  Tooltip,
} from '@metservicedev/met-ui';
import React from 'react';

type Props = {
  'data-testid'?: string;
  tooltipContent?: React.ReactNode;
};

export const InfoToolTip: React.FC<Props> = ({
  'data-testid': testId,
  tooltipContent,
}) => (
  <Tooltip
    content={<Text w={60} color="text.inverse" as="div">{tooltipContent}</Text>}
    displayArrow={false}
    interactive
    data-testid={testId}
  >
    <Icon
      as={GeInfo}
      size="2xs"
      color="icon.information"
      bg="fill"
      borderRadius="full"
    />
  </Tooltip>
);
